import {Component, OnInit} from '@angular/core';
import {UserDomainService} from '../../user-domains/user-domain.service';
import {UserDomain} from '../../user-domains/user-domain';
import DataSource from 'devextreme/data/data_source';
import {AuthService, User} from 'shared';
import {UserService} from '../../services/user.service';
import {RoleService} from '../../services/role.service';
import {confirm} from 'devextreme/ui/dialog';

@Component({
  selector: 'app-users-grid',
  templateUrl: './users-grid.component.html',
  styleUrls: ['./users-grid.component.scss']
})
export class UsersGridComponent implements OnInit {

  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  canImpersonate: boolean;
  canSendPassword: boolean;

  roles;

  isNew = true;

  domains: UserDomain[];

  phonePattern: any = /^\+\s*212\s*\d\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{2}$/;
  current: User;

  constructor(
    private userDomainsService: UserDomainService,
    private service: UserService,
    private rolesService: RoleService,
    private authService: AuthService,
    private user: User,
  ) {

    // User domains
    this.domains = userDomainsService.domains;

    // Data source
    this.ds = service.newDataSource();
    this.roles = rolesService.list();

    // Permissions
    this.canEdit = user.can('edit users');
    this.canAdd = user.can('add users');
    this.canDelete = user.can('delete users');
    this.canImpersonate = user.can('impersonate');
    this.canSendPassword = user.can('send user password');

    // Bindings
    this.sendNewPassword = this.sendNewPassword.bind(this);
    this.impersonateUser = this.impersonateUser.bind(this);
    this.emailValidation = this.emailValidation.bind(this);
  }

  ngOnInit() {
  }

  onEdit(e: any) {
    this.isNew = false;
    this.current = e.data;
  }

  onCreate() {
    this.isNew = true;
  }

  async sendNewPassword(e: any) {
    const send = await confirm('Voulez-vous envoyer un nouveau mot de passe à l\'utilisateur?', 'Confirmation');
    if (!send) {
      return;
    }
    e.component.beginCustomLoading('Opération en cours...');
    this.service.sendNewPassword(e.row.data.id).subscribe().add(() => {
      e.component.endCustomLoading();
    });
  }

  impersonateUser(e: any) {
    e.component.beginCustomLoading('Opération en cours...');
    /*    this.authService.impersonate(e.row.data.id).subscribe().add(() => {
          e.component.endCustomLoading();
        });*/
  }

  emailValidation(params: any) {
    return this.service.checkEmail(params.value, params.data?.id).toPromise();
  }

  calculateFilterExpression(filterValue, selectedFilterOperation) {
    const column = this as any;
    return [column.dataField, 'contains', filterValue];
  }
}
